import { render } from "./QwRadio.vue?vue&type=template&id=4ed97047"
import script from "./QwRadio.vue?vue&type=script&lang=js"
export * from "./QwRadio.vue?vue&type=script&lang=js"

import "./QwRadio.vue?vue&type=style&index=0&id=4ed97047&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__